<template>
    <async-btn
            :task="task"
            label="Restore"
            v-bind="$attrs"
            @click="restoreAll"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { restore, trash } from './post';

interface Data {
  task: Promise<Post>|null,
}

export default defineComponent({
  emits: ['restored', 'trashed'],
  components: { AsyncBtn },
  props: {
    postId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    restoreAll() {
      const vm = this;
      this.task = restore(this.postId);
      this.task.then((post: Post) => {
        this.$emit('restored', post);
        notify({
          message: 'Post restored.',
          actions: [
            {
              label: 'Undo',
              handler() {
                vm.undo(post);
              },
            },
          ],
        });
      });
    },
    undo(post: Post) {
      this.task = trash(post.id);
      this.task.then((p: Post) => {
        this.$emit('trashed', p);
        notify('Post trashed.');
      });
    },
  },
});
</script>
